export enum ThirdPartyFormTab {
  Addresses = 'addresses',
  BankInfo = 'bankInfo',
  BillEmitters = 'billEmitters',
  BillReceiver = 'billReceiver',
  ChildOrganizations = 'childOrganizations',
  OrganizationMemberships = 'organizationMemberships',
  OrganizationMembershipsDetails = 'organizationMembershipsDetails',
  ContactInfo = 'contactInfo',
  GeneralInfo = 'generalInfo',
  MotherOrganization = 'motherOrganization',
  PersonMemberships = 'personMemberships',
  PersonMembershipsDetails = 'personMembershipsDetails',
}
